import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SurveyResultsLayer from "../components/Survey/SurveyResultsLayer";

const SurveysPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Surveys" />
      <SurveyResultsLayer />
    </MasterLayout>
  );
};

export default SurveysPage;
